const getQueryParams = url => {
    const queryParams = {};

    const queryString = url.split('?')[1];

    if (queryString) {
        queryString.split('&').forEach(item => {
            if(item) {
                const [key, value] = item.split('=');
                queryParams[key] = value;
            }
        });
    }

    return queryParams;
};

export default getQueryParams;
